export default "__VITE_ASSET__Bmlp1tXA__"